import React from 'react';
import { useTheme } from '@mui/material';

const JamIcon = ({ color, size = 24, icon, style }) => {
  
  const theme = useTheme()
  return (
  <span
    className={`jam jam-${icon}`}
    style={{
      ...style,
      color: color || theme.palette.colors.black100,
      fontSize: size
    }}
  />
)}

export default JamIcon;
